export default "__VITE_PUBLIC_ASSET__2e9a1c5f__"